export interface GetOfficialAcceptCollectionRequest {
  id: number
  collectionNo: string
  acceptDate: string
}

export function GetOfficialAcceptCollectionRequestToJSON(
  value: GetOfficialAcceptCollectionRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined,
    accept_date: value.acceptDate !== '' ? value.acceptDate : undefined
  }
}
